import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import css from './UpcomingEvent.module.scss';
import { ArrowRight, Image } from '@outdoor-voices/ui';
import { getEvent } from '../queries';
import { OV_EVENTS_GRAPHQL_URL } from '../../../config/theme';
import { POST_HEADERS } from '../../../config/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var loadEvent = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var eventsMarketSlug, setEventData, setHasUpcomingEvent, padded, today, date, request, response, eventEdges, hasEvent, eventDate;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            eventsMarketSlug = _ref.eventsMarketSlug, setEventData = _ref.setEventData, setHasUpcomingEvent = _ref.setHasUpcomingEvent;

            padded = function padded(num) {
              return num < 10 ? "0".concat(num) : "".concat(num);
            };

            today = new Date();
            date = "".concat(today.getFullYear(), "-").concat(padded(today.getMonth() + 1), "-").concat(padded(today.getDate()));
            _context.prev = 4;
            _context.next = 7;
            return fetch(OV_EVENTS_GRAPHQL_URL, _objectSpread(_objectSpread({}, POST_HEADERS), {}, {
              body: JSON.stringify({
                query: getEvent,
                variables: {
                  date: date,
                  marketSlug: eventsMarketSlug
                }
              })
            }));

          case 7:
            request = _context.sent;
            _context.next = 10;
            return request.json();

          case 10:
            response = _context.sent;
            eventEdges = response.data.eventDates.edges;
            hasEvent = eventEdges.length > 0;

            if (hasEvent) {
              eventDate = eventEdges[0].node;
              setHasUpcomingEvent(true);
              setEventData(eventDate);
            }

            _context.next = 19;
            break;

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](4);
            console.error('Shop upcoming event error: ', _context.t0);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 16]]);
  }));

  return function loadEvent(_x) {
    return _ref2.apply(this, arguments);
  };
}();

export var formatDate = function formatDate(date) {
  var dateObject = new Date(date.replace(/-/g, '/'));
  var weekdayStr = dateObject.toLocaleDateString('en-us', {
    weekday: 'long'
  });
  var monthStr = dateObject.toLocaleDateString('en-us', {
    month: 'long'
  });
  var dayStr = dateObject.toLocaleDateString('en-us', {
    day: 'numeric'
  });
  return "".concat(weekdayStr, ", ").concat(monthStr, " ").concat(formatOrdinal(dayStr));
};
export var formatOrdinal = function formatOrdinal(number) {
  var endings = ['th', 'st', 'nd', 'rd'];
  var v = number % 100;
  return number + (endings[(v - 20) % 10] || endings[v] || endings[0]);
};
export var formatTime = function formatTime(time) {
  var hours = time.split(':')[0];
  var minutes = time.split(':')[1];
  var end = hours >= 12 ? 'PM' : 'AM';
  var hours12 = hours % 12 || 12;
  return "".concat(hours12, ":").concat(minutes, " ").concat(end);
};

var UpcomingEvent = function UpcomingEvent(_ref3) {
  var data = _ref3.data;
  if (!data) return null;
  var _data$event = data.event,
      _data$event$category = _data$event.category,
      categoryName = _data$event$category.name,
      categoryImage = _data$event$category.image,
      eventImage = _data$event.image,
      name = _data$event.name,
      _data$event$dates$edg = _data$event.dates.edges[0].node,
      eventDate = _data$event$dates$edg.date,
      eventEndTime = _data$event$dates$edg.timeEnd,
      eventStartTime = _data$event$dates$edg.timeStart,
      url = data.url;
  var image = eventImage ? eventImage : categoryImage;
  var date = formatDate(eventDate);
  var startTime = formatTime(eventStartTime);
  var endTime = formatTime(eventEndTime);
  return /*#__PURE__*/_jsxs("div", {
    className: css.upcomingEvent,
    children: [/*#__PURE__*/_jsx("h3", {
      className: css.eventTitle,
      children: "Upcoming Event"
    }), /*#__PURE__*/_jsxs("div", {
      className: css.eventContent,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.categoryImage,
        children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
          sizes: [90],
          wrap: false
        }))
      }), /*#__PURE__*/_jsxs("div", {
        className: css.eventInfo,
        children: [/*#__PURE__*/_jsx("div", {
          className: css.categoryName,
          children: categoryName
        }), /*#__PURE__*/_jsx("div", {
          className: css.eventName,
          children: name
        }), /*#__PURE__*/_jsx("div", {
          className: css.eventDate,
          children: "".concat(date, " | ").concat(startTime, " \u2014 ").concat(endTime)
        }), /*#__PURE__*/_jsxs("a", {
          "aria-label": 'Click to view event detail page',
          className: cc([css.url, css.eventUrl]),
          href: url,
          children: ["View more details ", /*#__PURE__*/_jsx(ArrowRight, {})]
        })]
      })]
    }), /*#__PURE__*/_jsx("a", {
      className: cc([css.url, css.allEvents]),
      href: 'https://events.outdoorvoices.com',
      children: "View all upcoming events"
    })]
  });
};

UpcomingEvent.propTypes = {
  data: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape().isRequired])
};

var UpcomingEventLoader = function UpcomingEventLoader(_ref4) {
  var eventsMarketSlug = _ref4.eventsMarketSlug;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasUpcomingEvent = _useState2[0],
      setHasUpcomingEvent = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      eventData = _useState4[0],
      setEventData = _useState4[1];

  useEffect(function () {
    if (!eventsMarketSlug) return;
    loadEvent({
      eventsMarketSlug: eventsMarketSlug,
      setEventData: setEventData,
      setHasUpcomingEvent: setHasUpcomingEvent
    });
  }, [eventsMarketSlug]);
  return hasUpcomingEvent && /*#__PURE__*/_jsx(UpcomingEvent, {
    data: eventData
  });
};

UpcomingEventLoader.propTypes = {
  eventsMarketSlug: PropTypes.string.isRequired
};
export default UpcomingEventLoader;